import React from "react";
import ReactDOM from "react-dom/client";
import {Provider} from "react-redux";
import {WebcastAuctionConnectData_TypeDef} from "@nextlot/core/webcast/services/AuctionsManager";
import {DataStore} from "@nextlot/core/webcast";
import AuctionsManager from "@nextlot/core/webcast/services/AuctionsManager";
import {NextLotJSDATA_TypeDef} from "@nextlot/core/NextLotJSDATA";
import OnsiteRootCmp from "./components/onsite/OnsiteRootCmp";


export function load(appConfigData: NextLotJSDATA_TypeDef, webcastSaleConnectData: WebcastAuctionConnectData_TypeDef) {
    console.log('NLWebcast: --- loading ONSITE screen: ', webcastSaleConnectData);

    const el_cmp_RootCmp = document.getElementById('cmp_RootCmp');
    if (el_cmp_RootCmp) {

        DataStore.init(appConfigData);

        AuctionsManager.init(DataStore.reduxStore);

        AuctionsManager.createWebcastAuctionHandler(webcastSaleConnectData);


        ReactDOM.createRoot(el_cmp_RootCmp!)
            .render(
                <Provider store={DataStore.reduxStore}>
                    <OnsiteRootCmp />
                </Provider>
            );
    }
    else {
        alert('Fatal error: HTML DOM element `#cmp_RootCmp` not found!');
        throw 'HTML DOM element cmp_RootCmp not found.';
    }

}
